import React, { useEffect } from 'react';
import i18n from 'i18next';
import {
  getStatus,
} from 'redux-resource';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  State,
  coreActions,
  coreSelectors,
  BasicNotification,
} from '@gymcloud/core';

import {
  Spinner,
  Tooltip,
  NotFound,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from '../styled';

const tooltipTexts = {
  activity: 'This area displays recent activity involving you and your clients',
};

const getActivityTo = (activity: BasicNotification): string => {
  switch (activity.key) {
    case 'personal_program.create':
      return `/personal_programs/${activity.trackable_id}`;
    case 'personal_workout.create':
      return `/personal_workouts/${activity.trackable_id}`;
    case 'user.invitation_accepted':
      return `/users/${activity.trackable_id}/programs`;
    case 'exercise_result.create':
      return `/events/${activity.trackable_id}`;
    case 'video.create':
      return `/users/${activity.owner_id}/videos`;
    default:
      return `/workout_events/${activity.trackable_id}`;
  }
};

const mapState = (state: State) => {
  const profile = coreSelectors.getProfile(state);
  return {
    profile,
    readStatus: getStatus(
      state,
      [
        'notifications.requests.fetchNotifications.status',
      ],
      true,
    ),
    notifications: coreSelectors.getNotifications(
      String(profile.id),
    )(state),
  };
};

const Activity = () => {
  const dispatch = useDispatch();
  const {
    profile,
    readStatus,
    notifications,
  } = useSelector(mapState);

  useEffect(() => {
    dispatch(
      coreActions.requestNotifications(profile.id),
    );
  }, []);

  if (readStatus.pending) {
    return (
      <Spinner message="Loading Activity..." />
    );
  }

  if (readStatus.failed) {
    return (
      <NotFound title="Error" />
    );
  }

  return (
    <Flex
      column
      width="100%"
    >
      <Flex
        width="100%"
        align="center"
        justify="center"
      >
        {
          profile.is_pro
            ? (
              <Tooltip
                body={tooltipTexts.activity}
                preferPlace="above"
                width="200px"
              >
                <Text color="#757575">
                  Recent Activity:
                </Text>
              </Tooltip>
            )
            : (
              <Text color="#757575">
                Recent Activity:
              </Text>
            )
        }
      </Flex>
      <Flex column width="100%">
        {notifications.map(item => (
          <Flex
            key={item.id}
            width="100%"
            padding="10px 0"
            borderBottom="1px solid #ededed"
          >
            <Flex align="center">
              <Flex flex="0 0 36px" align="center">
                <S.ActivityIcon itemKey={item.key} />
              </Flex>
              <S.ActivityLink to={getActivityTo(item)}>
                {`${item.owner_full_name || ''} ${i18n.t(`event.${item.key}`,
                  { name: item.trackable_name ? i18n.t(item.trackable_name) : '' })}`}
              </S.ActivityLink>
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export default Activity;
